import React from 'react';
import styled from 'styled-components';
import Row from 'components/Common/Row';
import Expectation from 'components/DriverAX/components/Expectation';
import Typography from 'kingpin/atoms/Typography';
import useBonusEligibility from '../../hooks/useBonusEligibility';

const QUALIFIED_BACKGROUND = 'var(--color-success-bg)';
const DISQUALIFIED_BACKGROUND = 'var(--color-danger-bg)';

const OuterDiv = styled.div<{ isOpen: boolean; isQualified: boolean }>`
  width: 100%;
  border-radius: 8px;
  padding: 0px 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  border-width: 1px;
  border-style: solid;

  // state dependant - isQualified
  border-color: ${(props) =>
    props.isQualified
      ? 'var(--color-success-border)'
      : 'var(--color-danger-border)'};
  background-color: ${(props) =>
    props.isQualified ? QUALIFIED_BACKGROUND : DISQUALIFIED_BACKGROUND};
`;

const InnerDiv = styled.div<{ isQualified: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px 0;

  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: ${(props) =>
    props.isQualified
      ? 'var(--color-success-border)'
      : 'var(--color-danger-border)'};
`;

const BonusEligibilityTooltip = ({
  bonusProgram,
  rewardOutput,
}: {
  bonusProgram: BonusTypes.BonusProgram;
  rewardOutput: BonusTypes.Rewards.AnyDriverRewardsOutput;
}) => {
  const { isQualified, expectations, StatusIcon } = useBonusEligibility({
    bonusProgram,
    rewardOutput,
  });

  return (
    <>
      <OuterDiv isOpen isQualified={isQualified}>
        <Row spaceBetween centerAlign style={{ height: 56 }}>
          <Row centerAlign style={{ gap: 8 }}>
            {StatusIcon}
            <Typography.Header type={'H5'}>
              {`Bonus Eligibility: ${isQualified ? 'Unlocked' : 'Disqualified'}`}
            </Typography.Header>
          </Row>
        </Row>

        <InnerDiv isQualified={isQualified}>
          {expectations.map((e) => (
            <Expectation {...e} variant={'tooltip'} />
          ))}
        </InnerDiv>
      </OuterDiv>
    </>
  );
};
export default BonusEligibilityTooltip;
